import { Arbeitsbereich } from '@/domain/navigation/benachrichtigungen/types/Benachrichtungen';
import { mapMarkierung } from '@/domain/navigation/benachrichtigungen/utils/mapMarkierung';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CSSProperties } from 'react';

type StyleProps = CSSProperties & {
  '--dot-color': CSSProperties['color'];
};

export function ArbeitsBereichBadge({
  arbeitsbereich,
}: {
  arbeitsbereich: Arbeitsbereich;
}) {
  return (
    <div className="flex flex-row gap-2 items-center">
      <FontAwesomeIcon
        icon={faCircle}
        className="max-w-2.5 max-h-2.5 text-(--dot-color)"
        style={
          {
            '--dot-color': mapMarkierung[arbeitsbereich.markierung].base,
          } as StyleProps
        }
      />
      <span className="text-neutrals-900 text-sm ">{arbeitsbereich.name}</span>
    </div>
  );
}
